<div class="container-fluid">
  <div class="row">
    <div class="modal-header border-0 offset-md-10 col-md-2">
      <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</div>
<div class="container-fluid pb-5 h-100">
  <cadastro-regra *ngIf="!data.composta" [regra]="data.regra" #cadastroComponent [isConsulta]="data.isConsulta" [functionEnabled]="false" (closeDialog)="closeDialog()"></cadastro-regra>
  <regra-composta-stepper *ngIf="data.composta" [regra]="data.regra" [isConsulta]="data.isConsulta" (closeDialog)="closeDialog()"></regra-composta-stepper>
</div>

